// extracted by mini-css-extract-plugin
export var contentBody = "_7w-9";
export var headerImage = "_7w-2";
export var imageButton = "_7w-7";
export var imageButtonIcon = "_7w-8";
export var imageHeader = "_7w-4";
export var imageHeaderText = "_7w-5";
export var imageOverlay = "_7w-3";
export var imageTitle = "_7w-6";
export var imageWrapper = "_7w-1";
export var taskList = "_7w-a";
export var widget = "_7w-0";